import { render, staticRenderFns } from "./DataTableCardPKCProcesses.vue?vue&type=template&id=3bb526fa"
import script from "./DataTableCardPKCProcesses.vue?vue&type=script&lang=js"
export * from "./DataTableCardPKCProcesses.vue?vue&type=script&lang=js"
import style0 from "./DataTableCardPKCProcesses.vue?vue&type=style&index=0&id=3bb526fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports